import { ControlTypes, ControlActionTypes } from "./controlTypes";
import { ControlResponse } from "@/main/models/response/controlResponse";

export function getControlsByScreen(guidScreen: string): ControlActionTypes {
	return {
		type: ControlTypes.GET_CONTROLS_BY_SCREEN,
		payload: { guidScreen },
	};
}

export function saveControlsByScreen(
	data: ControlResponse[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): ControlActionTypes {
	return {
		type: ControlTypes.SAVE_CONTROLS_BY_SCREEN,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerControlsByScreen(): ControlActionTypes {
	return {
		type: ControlTypes.RESET_REDUCER_CONTROLS_BY_SCREEN,
	};
}
